import React from 'react';
import Login from '../../../components/UI/Login/Login';
 
const LoginPage = () => {
  return  <Login></Login>  ;
}

export default LoginPage;